import { render, staticRenderFns } from "./DashAlert.vue?vue&type=template&id=d1912f0a"
import script from "./DashAlert.vue?vue&type=script&lang=js"
export * from "./DashAlert.vue?vue&type=script&lang=js"
import style0 from "./DashAlert.vue?vue&type=style&index=0&id=d1912f0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports